import types from "./api.types";

export const setAPIError = (error) => {
    return { type: types.SET_API_ERROR, payload: error };
};

export const clearApiError = () => {
    return { type: types.CLEAR_API_ERROR };
};
